/**
 * @generated SignedSource<<119989da83bec0289d7b57b807592446>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveVideoButton_GetCurrentUserQuery$variables = Record<PropertyKey, never>;
export type RemoveVideoButton_GetCurrentUserQuery$data = {
  readonly currentUser: {
    readonly firms: ReadonlyArray<{
      readonly slug: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type RemoveVideoButton_GetCurrentUserQuery = {
  response: RemoveVideoButton_GetCurrentUserQuery$data;
  variables: RemoveVideoButton_GetCurrentUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveVideoButton_GetCurrentUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Firm",
            "kind": "LinkedField",
            "name": "firms",
            "plural": true,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RemoveVideoButton_GetCurrentUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Firm",
            "kind": "LinkedField",
            "name": "firms",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "655a8e18f5393d49015e1816b76faa42",
    "id": null,
    "metadata": {},
    "name": "RemoveVideoButton_GetCurrentUserQuery",
    "operationKind": "query",
    "text": "query RemoveVideoButton_GetCurrentUserQuery {\n  currentUser {\n    firms {\n      slug\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "50ae92dab96f1fdb16cf6ccc6d26eed7";

export default node;
